"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.gtvHash = exports.decode = exports.encode = void 0;
const merklehashts_1 = require("merklehashts");
const serialization = __importStar(require("../gtx/serialization"));
const constants_1 = require("../utils/constants");
const gtvHash2 = (obj, merkleHashVersion) => {
    if (!Object.values(constants_1.MERKLE_HASH_VERSIONS).includes(merkleHashVersion)) {
        throw new Error("Merkle hash version is not valid");
    }
    if (isNaN(merkleHashVersion)) {
        throw new Error("Merkle hash version is not set");
    }
    return (0, merklehashts_1.gtvHash)(obj, merkleHashVersion);
};
exports.gtvHash = gtvHash2;
const encode = serialization.encodeValue;
exports.encode = encode;
const decode = serialization.decodeValue;
exports.decode = decode;
//# sourceMappingURL=index.js.map